
const getParameters = function () {
  var search = window.location.search.slice(1);
  return search.length > 0 ? search.split('&')
  .map(p => p.split('='))
  .reduce((obj, pair) => {
    const [key, value] = pair.map(decodeURIComponent);
    return ({ ...obj, [key]: value.split('|') })
  }, {}) : {};
};

const constructParameters = function(parameters){
  return Object.keys(parameters).map(function(k) {
    return encodeURIComponent(k) + '=' + encodeURIComponent(parameters[k])
  }).join('&')
};

const update = function(parameters) {
  for(var property in parameters) {
    parameters[property] = parameters[property].join('|');
  }
  const param = (Object.keys(parameters).length === 0) ? '' : '?' + constructParameters(parameters);
  const url = `${window.location.protocol}//${window.location.host + window.location.pathname + param}`;
  window.history.pushState({path: url}, '', url);
};

const add = function (key, value, single = false) {
  if (history.pushState) {
		if(!hasValue(key, value)) {
			const parameters = getParameters();
	    if(!single && parameters[key]) {
	      parameters[key].push(value);
	    } else {
	      parameters[key] = [value];
	    }
	    update(parameters);
		}
  }
};

const getSingleValue = (key) => {
	if (history.pushState) {
		const parameters = getParameters();
		var currentParam = parameters[key];
		return currentParam;
	}
};

const hasValue = function(key, value) {
	if (history.pushState) {
		const parameters = getParameters();
		var currentParams = parameters[key];
		if(currentParams) {
			return currentParams.indexOf(value) != -1;
		}
		return false;
	}
};

const remove = function (key, value, single = false) {
  if (history.pushState) {
    const parameters = getParameters();
    var currentParams = parameters[key];
    if(currentParams) {
			if(single) {
				delete parameters[key];
			} else {
				var currentIndex = currentParams.indexOf(value);
				if(currentIndex > -1) {
					currentParams.splice(currentIndex, 1);
					if(currentParams.length == 0) {
						delete parameters[key];
					}
				}
			}
			update(parameters);
    }
  }
};

const clear = function () {
  update({});
};

const querystring = {
  add,
  remove,
  clear,
	hasValue,
  getParameters,
	getSingleValue,
};

export default querystring;



// WEBPACK FOOTER //
// ../shared/helpers/querystring.js